// ============================================================
// Site URLs (content pack 16 Oct 2026, section 1: "Auckland" in
// service URLs). Old URLs 301 here via public/_redirects.
// Suburb/area pages (S13) are on hold, so they have no paths yet.
// ============================================================

export const paths = {
  home: '/',
  houseHub: '/house-cleaning-auckland',
  prices: '/house-cleaning-prices-auckland',
  inspection: '/house-cleaning-prices-auckland#inspection',
  regular: '/regular-house-cleaning-auckland',
  deep: '/deep-cleaning-auckland',
  endOfTenancy: '/end-of-tenancy-cleaning-auckland',
  ovenCarpet: '/oven-and-carpet-cleaning-auckland',
  commercial: '/commercial-cleaning-auckland',
  office: '/office-cleaning-auckland',
  school: '/school-cleaning-auckland',
  about: '/about',
  projects: '/projects',
  contact: '/contact',
  blog: '/blog',
};

export const blogPaths = {
  houseCleaningCost: '/blog/how-much-does-house-cleaning-cost-auckland',
  endOfTenancyChecklist: '/blog/end-of-tenancy-cleaning-checklist-nz',
  deepVsRegular: '/blog/deep-clean-vs-regular-clean',
  commercialCost: '/blog/commercial-cleaning-cost-auckland',
  officeFrequency: '/blog/how-often-should-an-office-be-cleaned',
  moveInChecklist: '/blog/move-in-cleaning-checklist-nz',
  twoBedroomCost: '/blog/how-much-does-a-2-bedroom-clean-cost-auckland',
  airbnbChecklist: '/blog/airbnb-short-stay-cleaning-checklist-nz',
  springChecklist: '/blog/spring-cleaning-checklist-nz',
  prepareForCleaner: '/blog/how-to-prepare-for-a-house-cleaner',
  howOftenToClean: '/blog/how-often-should-you-clean-your-house-nz',
};

// Pages that belong to the house (domestic) or commercial half of the site,
// so the shared menu CTA and footer copy follow the visitor's context.
export const domesticPaths = [paths.houseHub, paths.prices, paths.regular, paths.deep, paths.endOfTenancy, paths.ovenCarpet];
export const commercialPaths = [paths.commercial, paths.office, paths.school];
